/**
 * các hàm dùng cho ký token = CA;
 */

import * as moment from "moment";
import { vgca_sign_issued } from "../assets/plugin/vgcaplugin";

const SIGN_BCYCP = {
  STATUS: {
    SUCCESS: 0
  }
};

const signBcycpTokenService = {
  signPdf({ fileUrl, docCode, docDate, FileUploadHandler }) {
    console.log(fileUrl);
    let params = {
      FileUploadHandler: FileUploadHandler,
      SessionId: "",
      FileName: fileUrl,
      DocNumber: docCode,
      IssuedDate: new moment(docDate).format()
    };
    console.log(fileUrl);
    // console.log(vgca_sign_issued);
    console.log(JSON.stringify(params))
    return new Promise(resolve => {
      vgca_sign_issued(JSON.stringify(params), responseStr => {
        // console.log(responseStr);
        let response = JSON.parse(responseStr);
        if (response.Status === SIGN_BCYCP.STATUS.SUCCESS) {
          resolve();
        }
      });
    });
  }
};

export default signBcycpTokenService;



// WEBPACK FOOTER //
// ./src/services/signBcycpTokenService.js